
<iframe class="display-window" *ngIf="documentLink" [src]="documentLink" allowfullscreen></iframe>